import { render, staticRenderFns } from "./PopoverTooltip.vue?vue&type=template&id=4d868228&scoped=true&"
import script from "./PopoverTooltip.vue?vue&type=script&lang=js&"
export * from "./PopoverTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d868228",
  null
  
)

export default component.exports